import {
  API_ERROR,
  INPUT_CHANGEVALUE,
  SELECT_CHANGEVALUE,
  SR_INPUT_CHANGEVALUE,
  SR_SELECT_CHANGEVALUE,
  SI_INPUT_CHANGEVALUE,
  ITEM_QTY_CHANGEVALUE,
  ITEM_UNITES_CHANGEVALUE,
  SI_SELECT_CHANGEVALUE,
  PRODUCTS_REQUEST_LIST,
  PRODUCTS_REQUEST_LIST_SUCCESS,
  PRODUCTS_ROW_REQUEST,
  PRODUCTS_ROW_REQUEST_SUCCESS,
  SELECTED_PRODUCTS_LIST,
  REMOVE_SELECTED_PRODUCT,
  SERVICEREQUEST_ADD,
  SERVICEREQUEST_ADD_SUCCESS,
  MODEL_OPEN,
  MODEL_CLOSE,
  MODEL_LIST_OPEN,
  MODEL_LIST_CLOSE,
  MY_SERVICEREQUEST_LIST,
  SERVICEREQUEST_LIST,
  DEPT_SERVICEREQUEST_LIST,
  ALL_SERVICEREQUEST_LIST,
  SERVICEREQUEST_LIST_COUNT,
  MY_SERVICEREQUEST_LIST_COUNT,
  DEPT_SERVICEREQUEST_LIST_COUNT,
  ALL_SERVICEREQUEST_LIST_COUNT,
  SERVICEREQUEST_LIST_COUNT_SUCCESS,
  GET_USER_DEPARTMENT,
  USER_DEPARTMENT_SUCCESS,
  SERVICEREQUEST_ROW_DATA,
  SERVICEREQUEST_ROW_DATA_SUCCESS,
  SERVICEREQUEST_LIST_SUCCESS,
  ITEM_HOD_APPROVAL,
  SR_ITEM_HOD_APPROVAL,
  ALL_SR_HOD_ITEM_LIST_CHECKED,
  SR_HOD_ITEM_LIST_CHECKED,
  SR_DEPT_HOD_APPROVE_ADD,
  SR_HOD_APPROVE_ADD,
  MT_ROW_LOADING,
  C_PRODUCT_IMAGE,
  C_PRODUCT_CHANGEVALUE,
  C_PRODUCT_SELECT_CHANGEVALUE,
  CHANGE_TOGGALE_TAB,
  SET_PARAMS,
  FILTER_INPUT_CHANGEVALUE,
  FILTER_SELECT_CHANGEVALUE,
  LIST_LAYOUT,
  TOGGLE_ITEM_MENU,
  SERVICEREQUEST_DELETE,
  CUSTOM_PRODUCT_ADD,
  CUSTOMPRODUCT_ADD_SUCCESS,
  CHANGE_ITEM_MODEL_OPEN,
  CHANGE_ITEM_MODEL_CLOSE,
  C_PRODUCT_RIGHT_SIDEBAR,
  C_PRODUCT_HIDE_RIGHT_SIDEBAR,
  CHANGE_ACTIVATE_PRODUCT,
  FILTERS_SHOW_RIGHT_SIDEBAR,
  FILTERS_HIDE_RIGHT_SIDEBAR,
  CLEAR_FILTER,
  VIEW_LOG_SHOW_RIGHT_SIDEBAR,
  VIEW_LOG_HIDE_RIGHT_SIDEBAR,
  SR_ITEM_TIME_LINE,
  ITEM_TIME_LINE_SUCCESSFUL,
  PI_ITEM_TIME_LINE,
  PO_ITEM_TIME_LINE,
  IGP_ITEM_TIME_LINE,
  PRODUCT_STORE_QTY,
  PRODUCT_STORE_QTY_SUCCESSFUL,
  PDF_DOWNNLOAD,
  CLEAR_DATA,
  PRODUCT_HISTORY,
  PRODUCT_HISTORY_SUCCESSFUL,
  PRODUCT_HISTORY_MODEL_CLOSE,
  SRI_STORE_USER_APPROVAL,
  SRI_STORE_HOD_APPROVAL,
  SR_PRODUCT_ITEM_HISTORY_MODEL_OPEN,
  PRODUCT_ITEM_HISTORY_MODEL_CLOSE,
  SR_ITEM_IMAGES_UPLOAD,
  SR_ITEM_UPDATE_IMAGE,
  SERVICE_REQUEST_CLOSE,
  SRQ_FOCUS_POST,
  VIEW_SR_LOG_SHOW_RIGHT_SIDEBAR,
  VIEW_LOG_SR_HIDE_RIGHT_SIDEBAR,
  SR_MODEL_LIST_OPEN,
} from "./actionTypes";
export const InputChangeValue = ({ key, value }) => {
  return {
    type: INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const SelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const SRInputChangeValue = ({ key, value }) => {
  return {
    type: SR_INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};

export const SRSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SR_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const SIInputChangeValue = ({ key, value, item }) => {
  return {
    type: SI_INPUT_CHANGEVALUE,
    payload: { key, value, item },
  };
};
export const ItemQtyChangeValue = ({ key, value, item, status }) => {
  return {
    type: ITEM_QTY_CHANGEVALUE,
    payload: { key, value, item, status },
  };
};
export const ItemUnitsChangeValue = ({ label, value, item, status }) => {
  return {
    type: ITEM_UNITES_CHANGEVALUE,
    payload: { label, value, item, status },
  };
};
export const SISelecteChangeValue = ({ key, label, key2, value, item }) => {
  return {
    type: SI_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value, item },
  };
};

export const getAllProducts = (data, clearList) => {
  return {
    type: PRODUCTS_REQUEST_LIST,
    payload: { data, clearList },
  };
};
export const productsRequestListSuccessful = (request) => {
  return {
    type: PRODUCTS_REQUEST_LIST_SUCCESS,
    payload: request,
  };
};
export const getRowProducts = (id) => {
  return {
    type: PRODUCTS_ROW_REQUEST,
    payload: { id },
  };
};
export const productRowSuccessful = (request) => {
  return {
    type: PRODUCTS_ROW_REQUEST_SUCCESS,
    payload: request,
  };
};
export const SelectedProducts = ({ products }) => {
  return {
    type: SELECTED_PRODUCTS_LIST,
    payload: products,
  };
};
export const removeSelectProducts = (data) => {
  return {
    type: REMOVE_SELECTED_PRODUCT,
    payload: data,
  };
};
export const addServiceRequest = (material, materialId, history, callBack) => {
  return {
    type: SERVICEREQUEST_ADD,
    payload: { material, materialId, history, callBack },
  };
};
export const ServiceRequestAddSuccessful = (response) => {
  return {
    type: SERVICEREQUEST_ADD_SUCCESS,
    payload: response,
  };
};
export const model_open = () => {
  return {
    type: MODEL_OPEN,
    // payload: {  },
  };
};

export const model_close = () => {
  return {
    type: MODEL_CLOSE,
  };
};
export const modelListOpen = (id) => {
  return {
    type: SR_MODEL_LIST_OPEN,
    payload: { id },
  };
};

export const modelListClose = () => {
  return {
    type: MODEL_LIST_CLOSE,
  };
};
export const getMySRListcount = (data) => {
  return {
    type: MY_SERVICEREQUEST_LIST_COUNT,
    payload: { data },
  };
};
export const getDeptSRListcount = (data) => {
  return {
    type: DEPT_SERVICEREQUEST_LIST_COUNT,
    payload: { data },
  };
};
export const getServiceReqListcount = (data) => {
  return {
    type: SERVICEREQUEST_LIST_COUNT,
    payload: { data },
  };
};
export const getAllServiceReqListcount = (data) => {
  
  return {
    type: ALL_SERVICEREQUEST_LIST_COUNT,
    payload: { data },
  };
};
export const SRListCountSuccessful = (request) => {
  return {
    type: SERVICEREQUEST_LIST_COUNT_SUCCESS,
    payload: request,
  };
};
export const getMyServiceReqList = (data) => {
  return {
    type: MY_SERVICEREQUEST_LIST,
    payload: { data },
  };
};
export const getServiceReqList = (data) => {
  return {
    type: SERVICEREQUEST_LIST,
    payload: { data },
  };
};
export const getDetServiceReqList = (data) => {
  return {
    type: DEPT_SERVICEREQUEST_LIST,
    payload: { data },
  };
};
export const getAllServiceReqList = (data) => {
  return {
    type: ALL_SERVICEREQUEST_LIST,
    payload: { data },
  };
};
export const serviceRequestListSuccessful = (request) => {
  return {
    type: SERVICEREQUEST_LIST_SUCCESS,
    payload: request,
  };
};
export const getUserDepartment = (id) => {
  return {
    type: GET_USER_DEPARTMENT,
    payload: { id },
  };
};
export const UserDepartmentSuccessfull = (response) => {
  return {
    type: USER_DEPARTMENT_SUCCESS,
    payload: response,
  };
};

export const getReqestRowDetails = (id, timeLine = false) => {

  return {
    type: SERVICEREQUEST_ROW_DATA,
    payload: { id, timeLine },
  };
};

export const serviceRequestsuccessfull = (response) => {
  return {
    type: SERVICEREQUEST_ROW_DATA_SUCCESS,
    payload: response,
  };
};
export const toggleItemMenu = (id) => {
  return {
    type: TOGGLE_ITEM_MENU,
    payload: id,
  };
};
export const materialRequestDelete = (id) => {
  return {
    type: SERVICEREQUEST_DELETE,
    payload: { id },
  };
};

export const itemHodApproval = (data) => {
  return {
    type: ITEM_HOD_APPROVAL,
    payload: { data },
  };
};
export const SRHodApprovedRequest = (material, history) => {
  return {
    type: SR_HOD_APPROVE_ADD,
    payload: { material, history },
  };
};
export const AllMrHodItemsChecked = (checked) => {
  return {
    type: ALL_SR_HOD_ITEM_LIST_CHECKED,
    payload: { checked },
  };
};
export const MrHODItemsChecked = (checked, item, index) => {
  return {
    type: SR_HOD_ITEM_LIST_CHECKED,
    payload: { checked, item, index },
  };
};
export const SRISUserApproval = (data) => {
  return {
    type: SRI_STORE_USER_APPROVAL,
    payload: { data },
  };
};
export const SRISHodApproval = (data, PIData) => {
  return {
    type: SRI_STORE_HOD_APPROVAL,
    payload: { data, PIData },
  };
};
export const SRitemHodApproval = (data) => {
  return {
    type: SR_ITEM_HOD_APPROVAL,
    payload: { data },
  };
};
export const SRDeptHodApprovedRequest = (material, history) => {
  return {
    type: SR_DEPT_HOD_APPROVE_ADD,
    payload: { material, history },
  };
};

export const serviceRequestRowloading = (data) => {
  return {
    type: MT_ROW_LOADING,
    payload: data,
  };
};
export const CProductImage = (data) => {
  return {
    type: C_PRODUCT_IMAGE,
    payload: data,
  };
};
export const CProductChangeValue = ({ key, value }) => {
  return {
    type: C_PRODUCT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const CProductSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: C_PRODUCT_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const AddCustomProduct = (data) => {
  return {
    type: CUSTOM_PRODUCT_ADD,
    payload: { data },
  };
};
export const CostomproductAddSuccessful = (response) => {
  return {
    type: CUSTOMPRODUCT_ADD_SUCCESS,
    payload: { response },
  };
};

export const toggleTab = (tab) => {
  return {
    type: CHANGE_TOGGALE_TAB,
    payload: { tab },
  };
};
export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};
export const FilterChangeValue = ({ key, value }) => {
  return {
    type: FILTER_INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const FilterSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: FILTER_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const listlayout = (layout) => {
  return {
    type: LIST_LAYOUT,
    payload: layout,
  };
};
export const ChangeItemModelOpen = (item, SRlevel, PIData = false) => {
  return {
    type: CHANGE_ITEM_MODEL_OPEN,
    payload: { item, SRlevel, PIData },
  };
};
export const ChangeItemModelClose = () => {
  return {
    type: CHANGE_ITEM_MODEL_CLOSE,
    // payload: { item },
  };
};
export const productItemHistoryModelOpen = (data) => {
  return {
    type: SR_PRODUCT_ITEM_HISTORY_MODEL_OPEN,
    payload: { data },
  };
};
export const productItemHistoryModelClose = () => {
  return {
    type: PRODUCT_ITEM_HISTORY_MODEL_CLOSE,
    // payload: { item },
  };
};
export const CPRightSidebar = (item) => {
  return {
    type: C_PRODUCT_RIGHT_SIDEBAR,
    payload: { item },
  };
};

// export const showRightSidebar = () => ({
// 	type: SHOW_RIGHT_SIDEBAR,
// 	payload: null
// });

export const cProducthideRightSidebar = () => ({
  type: C_PRODUCT_HIDE_RIGHT_SIDEBAR,
  payload: null,
});
export const ProductActivateuccessful = (response) => {
  return {
    type: CHANGE_ACTIVATE_PRODUCT,
    payload: response,
  };
};
export const FiltersShowRightSidebar = (SRFilterlevel) => {
  return {
    type: FILTERS_SHOW_RIGHT_SIDEBAR,
    payload: { SRFilterlevel },
  };
};
export const FiltershideRightSidebar = () => ({
  type: FILTERS_HIDE_RIGHT_SIDEBAR,
  payload: null,
});
export const FilterClear = () => {
  return {
    type: CLEAR_FILTER,
    payload: null,
  };
};
export const viewLogShowRightSidebar = (SRId) => {
  return {
    type: VIEW_SR_LOG_SHOW_RIGHT_SIDEBAR,
    payload: { SRId },
  };
};
export const viewLoghideRightSidebar = () => ({
  type: VIEW_LOG_SR_HIDE_RIGHT_SIDEBAR,
  payload: null,
});
export const GetItemTimeLine = (SRItemId) => {
  return {
    type: SR_ITEM_TIME_LINE,
    payload: { SRItemId },
  };
};
export const GetItemTimeLineSuccessful = (response) => {
  return {
    type: ITEM_TIME_LINE_SUCCESSFUL,
    payload: response,
  };
};

export const GetPIItemTimeLine = (PIItem) => {
  return {
    type: PI_ITEM_TIME_LINE,
    payload: { PIItem },
  };
};
export const GetPOItemTimeLine = (POItem) => {
  return {
    type: PO_ITEM_TIME_LINE,
    payload: { POItem },
  };
};
export const GetIGPItemTimeLine = (IGPItem) => {
  return {
    type: IGP_ITEM_TIME_LINE,
    payload: { IGPItem },
  };
};
export const getProductStoreQty = (ProductID) => {
  return {
    type: PRODUCT_STORE_QTY,
    payload: { ProductID },
  };
};
export const getProductStoreQtySuccessful = (response) => {
  return {
    type: PRODUCT_STORE_QTY_SUCCESSFUL,
    payload: response,
  };
};
export const getPDFDownload = (SRId) => {
  return {
    type: PDF_DOWNNLOAD,
    payload: { SRId },
  };
};
export const clearData = () => {
  return {
    type: CLEAR_DATA,
  };
};
export const GetProductHistory = (ProductID) => {
  return {
    type: PRODUCT_HISTORY,
    payload: { ProductID },
  };
};
export const ProductHistorySuccessful = (response) => {
  return {
    type: PRODUCT_HISTORY_SUCCESSFUL,
    payload: response,
  };
};
export const productHistoryModel_close = () => {
  return {
    type: PRODUCT_HISTORY_MODEL_CLOSE,
    payload: null,
  };
};
export const uploadMultipleSRItemImages = (mrItemImage, ProductId) => {
  return {
    type: SR_ITEM_IMAGES_UPLOAD,
    payload: { mrItemImage, ProductId },
  };
};
export const UpdateSRImage = (data) => {
  return {
    type: SR_ITEM_UPDATE_IMAGE,
    payload: { data },
  };
};
export const materialRequestClose = (id) => {
  return {
    type: SERVICE_REQUEST_CLOSE,
    payload: { id },
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};


// SRQ Focus Post
export const mrqFocusPost = (id, data) => {
  return {
    type: SRQ_FOCUS_POST,
    payload: { id, data },
  };
};